import { useQuery } from '@tanstack/react-query';

import * as LoyaltyService from '~/services/LoyaltyService';

import { pointsPurchaseQueryKeys } from './pointsPurchaseQueryKeys';

export function useGetPointsPurchaseOfferCampaigns() {
  return useQuery({
    queryKey: pointsPurchaseQueryKeys.campaigns(),
    queryFn: async () => LoyaltyService.listPointsPurchaseOfferCampaigns(),
  });
}
